import { NameStateValues, updateKey } from './slice';
import * as Yup from 'yup';
import { updateKeyInStore } from 'App';
import React from 'react';

export const fields: IBaseField<keyof NameStateValues>[] = [
  {
    type: 'text',
    name: 'firstName',
    label: 'First Name',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    placeholder: 'First Name',
  },
  {
    type: 'text',
    name: 'middleName',
    label: 'Middle Name',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    placeholder: 'Middle Name',
  },
  {
    type: 'text',
    name: 'lastName',
    label: 'Last Name',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    placeholder: 'Last Name',
  },
  {
    type: 'maskedInput',
    name: 'socialSecurityNumber',
    label: 'Social Security Number',
    mask: '999-99-9999',
    subLabel: () => (
      <p>
        Exactly as it is shown on your Social Security card or enter 999-99-9999
        if not available.
      </p>
    ),
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    placeholder: 'Social Security Number',
  },
  {
    type: 'date',
    name: 'dateOfBirth',
    label: 'Date of Birth',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    placeholder: 'Date of Birth',
  },
  {
    type: 'text',
    name: 'profession',
    label: 'Profession',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    placeholder: 'Profession',
  },

  {
    type: 'radio',
    label: 'Do you have a State Issue ID/Drivers License?',
    name: 'doYouHaveAStateIssueIdDriversLicense',
    effect: updateKeyInStore(updateKey),
    dependencies: [
      {
        type: 'upload',
        predicate: (v) => v === 'yes',
        effect: updateKeyInStore(updateKey),
        label: 'Please upload your ID/Drivers License',
        name: 'pleaseUploadYourIdDriversLicense',
      },
    ],
  },
  {
    type: 'text',
    name: 'phoneNumber',
    label: 'Day time phone number',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    placeholder: 'Phone number',
  },
];

export const validationSchema = Yup.object().shape({
  firstName: Yup.string().required('required').nullable(),
  lastName: Yup.string().required('required').nullable(),
  socialSecurityNumber: Yup.string().required('required').nullable(),
  profession: Yup.string().required('required').nullable(),
  dateOfBirth: Yup.string().required('required').nullable(),
});
